import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'

const ManageLiveVideoCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [deleteConfirm, setDeleteConfirm] = useState({ show: false, id: null });
  const navigate = useNavigate();

  // Get auth token from localStorage
  const getAuthHeaders = () => {
    const token = localStorage.getItem('access_token');
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  };

  const fetchCategories = async (page = 1) => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/live-categories`, {
        headers: getAuthHeaders(),
        params: { page }
      });
      
      if (response.data.status) {
        setCategories(response.data.data || response.data.LiveCategories || []);
        setCurrentPage(response.data.pagination?.currentPage || page);
        setTotalPages(response.data.pagination?.totalPages || 1);
      }
    } catch (error) {
      console.error('Error fetching live categories:', error);
      setCategories([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_Baseurl}/admin/live-categories/${id}`, {
        headers: getAuthHeaders()
      });
      
      if (response.data.status) {
        alert('Live category deleted successfully!');
        fetchCategories(currentPage); // Refresh current page
      } else {
        alert('Failed to delete live category');
      }
    } catch (error) {
      console.error('Error deleting live category:', error);
      alert('Error deleting live category');
    }
    setDeleteConfirm({ show: false, id: null });
  };

  const handlePrevClick = () => {
    if (currentPage > 1) {
      fetchCategories(currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      fetchCategories(currentPage + 1);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <div>
         <div className=" m-0 p-0">
        <div className="">
          <section className="section all-video-stream container-fluid">
            <div className="iq-card mt-4">
              <div id="content-page" className="content-page">
                <div className="container-fluid">
                  <div className="admin-section-title">
                    <div className="">
                      <div className="row">
                        <div className="col-md-6">
                          <h4>
                            <i className="entypo-archive"></i> Live Stream
                            Categories
                          </h4>
                          <p>Organize The Categories Below:</p>
                        </div>
                        <div className="col-md-6" align="right">
                          <Link to="/admin/livestream-add-categories">
                            <button
                              type="button"
                              className="btn btn-primary"
                            >
                              <i className="fa fa-plus-circle"></i> Add Live Categories
                            </button>
                          </Link>
                        </div>
                      </div>

                      <div className="clear"></div>

                      {loading ? (
                        <div className="text-center py-4">
                          <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <p>Loading live categories...</p>
                        </div>
                      ) : (
                        <table
                          className="table table-bordered iq-card text-center"
                          id="categorytbl"
                        >
                          <thead>
                            <tr className="table-header r1">
                              <th>
                                <label>Category Image</label>
                              </th>
                              <th>
                                <label>Live Category Name</label>
                              </th>
                              <th>
                                <label>Uploaded by</label>
                              </th>
                              <th>
                                <label>Actions</label>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {categories.length > 0 ? (
                              categories.map((item, key) => (
                                <tr key={key}>
                                  <td className="table-content" valign="middle">
                                    <img 
                                      src={item.image || item.image_url || '/default-category.png'} 
                                      width="80px" 
                                      height="60px"
                                      alt={item.name}
                                      onError={(e) => {
                                        e.target.src = '/default-category.png';
                                      }}
                                    />
                                  </td>
                                  <td className="table-content" valign="middle">
                                    <strong>{item.name}</strong>
                                    {item.upload_on && (
                                      <><br/><small className="text-muted">{item.upload_on}</small></>
                                    )}
                                  </td>
                                  <td className="table-content" valign="middle">
                                    <span className="badge bg-secondary">
                                      {item.uploaded_by_name || 'Admin'}
                                    </span>
                                  </td>
                                  <td className="table-content" valign="middle">
                                    <div className="btn-group" role="group">
                                      <Link
                                        to={`/admin/livestream-edit-categories/${item.id}`}
                                        className="btn btn-sm btn-outline-primary"
                                        title="Edit"
                                      >
                                        <i className="fa fa-pencil-square" aria-hidden="true"></i>
                                      </Link>
                                      <button 
                                        className="btn btn-sm btn-outline-danger"
                                        onClick={() => setDeleteConfirm({ show: true, id: item.id })}
                                        title="Delete"
                                      >
                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="4" className="text-center py-4">
                                  <p className="mb-0">No live categories found</p>
                                  <small className="text-muted">Click 'Add Live Categories' to create your first category</small>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      )}

                      {/* Pagination */}
                      <div className="row text-center d-flex mt-3">
                        <div className="col-lg-4">
                          <button
                            type="button"
                            className={`btn btn-primary ${currentPage <= 1 ? 'disabled' : ''}`}
                            onClick={handlePrevClick}
                            disabled={currentPage <= 1}
                          >
                            {"<< Previous"}
                          </button>
                        </div>
                        <div className="col-lg-4">
                          <p className="mb-0">
                            Page {currentPage} of {totalPages}
                          </p>
                        </div>
                        <div className="col-lg-4">
                          <button
                            type="button"
                            className={`btn btn-primary ${currentPage >= totalPages ? 'disabled' : ''}`}
                            onClick={handleNextClick}
                            disabled={currentPage >= totalPages}
                          >
                            {"Next >>"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {deleteConfirm.show && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={() => setDeleteConfirm({ show: false, id: null })}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this live category? This action cannot be undone.</p>
              </div>
              <div className="modal-footer">
                <button 
                  type="button" 
                  className="btn btn-secondary" 
                  onClick={() => setDeleteConfirm({ show: false, id: null })}
                >
                  Cancel
                </button>
                <button 
                  type="button" 
                  className="btn btn-danger" 
                  onClick={() => handleDelete(deleteConfirm.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ManageLiveVideoCategories